import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import type { DialogProps } from "@material-ui/core/Dialog";
import { makeStyles, type Theme } from "@material-ui/core/styles";
import Dialog from "src/components/Dialog";
import { EditDialogContentWrapper } from "./EditDialogContentWrapper";
import type { EditDialogProps } from "./types";
import { getTourOpen } from "src/store/tour/selector";
import { setDialogReady } from "src/store/tour/actions";

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    height: "100%",
  },
}));

export function EditDialog({
  onClose,
  open,
  data,
  onDelete,
  loading,
  noCopyExpenseButton,
}: EditDialogProps) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const tourOpen = useSelector(getTourOpen);
  const [maxWidth, setMaxWidth] = useState<DialogProps["maxWidth"]>("sm");
  const handleClose = () => {
    onClose();
  };

  useEffect(() => {
    if (open) setMaxWidth("sm");
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth={maxWidth !== false}
      maxWidth={maxWidth}
      disableEnforceFocus
      classes={maxWidth !== "sm" && maxWidth !== false ? classes : undefined}
      TransitionProps={{
        onEntered: () => {
          if (tourOpen) dispatch(setDialogReady(true));
        },
      }}
    >
      <EditDialogContentWrapper
        onClose={onClose}
        data={data}
        onDelete={onDelete}
        loading={loading}
        noCopyExpenseButton={noCopyExpenseButton}
        onMaxWidthChange={(width: DialogProps["maxWidth"]) =>
          setMaxWidth(width)
        }
      />
    </Dialog>
  );
}
